























import Vue from 'vue'
import BusinessDetails from '@/components/Businesses/BusinessDetails.vue'
import BusinessIcon from '@/components/Businesses/BusinessIcon.vue'
import { apiGetBusinessDetails } from '@/api'
import { portalState } from '@/state'

export default Vue.extend({
  name: 'Treeview',
  components: { BusinessDetails, BusinessIcon },
  props: {
    businesses: Array,
    loadingBusinesses: Boolean
  },
  computed: {
    loggedInUser () { return portalState.user }
  },
  data () {
    return {
      search: '',
      loading: false,
      businessDetails: null,
      businessesFlattened: [],
      selected: []
    }
  },
  methods: {
    getBusinessDetails (id: string) {
      this.businessDetails = null
      this.loading = true
      apiGetBusinessDetails(id).then((res: any) => {
        this.businessDetails = res.data.data
        this.$emit('selectedBusiness', res.data.data)
        this.loading = false
      })
    },
    flatten (obj: {children: []}) {
      this.businessesFlattened.push(obj)
      if (!obj.children) return
      obj.children.forEach((child: {children: []}) => this.flatten(child))
    }
  },
  watch: {
    selected (businessIdArray) {
      if (businessIdArray.length && !this.loadingBusinesses) {
        this.getBusinessDetails(businessIdArray[0])
      } else {
        this.$emit('selectedBusiness', null)
        this.businessDetails = null
      }
    },
    businesses (val) {
      if (val.length === 1) this.selected = [val[0].id]
      this.flatten({ children: this.businesses })
      this.businessesFlattened.shift()
    },
    search (val) {
      if (!val) return
      const selectSearchedBusiness = () => {
        const searchResult = this.businessesFlattened.filter((b: {name: string}) => b.name.toLowerCase().includes(val.toLowerCase()))
        if (searchResult.length === 1) this.selected = [searchResult[0].id]
      }
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => selectSearchedBusiness(), 500)
    }
  }
})
